import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single, _WorkMaintenanceOrder } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { _FixedAssetItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const MD011 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestMaintenance);
    const order = useDataBean(_WorkMaintenanceOrder);

    const [props, setProps] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (props.IDProceudreIMP) {
            console.log("1")
            instance.getRequestMaintenanceCatalogPorPropiedades({ IDProceudreIMP: props.IDProceudreIMP }, null).then(
                (resp) => {
                    if (resp?.length > 0 && resp[0].DataBeanProperties) {
                        setBean({
                            ...resp[0].DataBeanProperties,
                        })
                    }
                }
            ).catch(
                err => { console.log("No se pudo cargar la informacion") }
            )
        }
    }, [props.IDProceudreIMP])

    const fixedAsset = useDataBean(_FixedAssetItem);


    const updateData = () => {
        instance.updateRequestMaintenance({ ...bean, State: 4 }).then(
            (resp) => {

                if (props.IDWorkMaintenanceOrder) {
                    order.instance.changeWorkMaintenanceOrderState(props.IDWorkMaintenanceOrder, 8).then(
                        (resp) => {
                            console.log(resp)
                        }
                    ).catch(err => { toast.error(err) })
                } else {
                    toast.error("No se pudo actualizar la orden de trabajo")
                }

                fixedAsset.instance.setOperationalStateToFixedAssetItem(
                    props.IDFixedAssetItem,
                    32,
                    _single.getAccountID()
                );

                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(
                        _single.jsonToBootstrapTable({
                            "Fecha de Entrega": bean.DeliveryDate,
                            "Hora de Entrega": `${pad(bean.DeliveryToH ?? 0)}:${pad(
                                bean.DeliveryToM ?? 0
                            )}`,
                            "Actividad realizada": bean.ActivityDescription,
                        })
                    );
                }
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap({ bean });
                }
            }
        ).catch(() => toast.error("No se pudo realizar la acción"));
    }

    const onExportMap = () => {
        const { valid, sameDay, isDeliveryBefore } = compareCalendarDay(bean.DeliveryDate, bean.ReportDate);
        if (!valid) {
            toast.error("Debe registrar Fecha de Entrega y Fecha de Reporte válidas.");
            return;
        }

        if (isDeliveryBefore) {
            toast.error("La Fecha de Entrega no puede ser anterior a la Fecha de Reporte.");
            return;
        }

        if (sameDay) {
            const dH = Number(bean.DeliveryToH);
            const dM = Number(bean.DeliveryToM);
            const rH = Number(bean.ReportTimeH);
            const rM = Number(bean.ReportTimeM);

            if (Number.isNaN(dH) || Number.isNaN(dM)) {
                toast.error("Debe seleccionar la Hora de Entrega (HH y MM).");
                return;
            }

            const delivery = dH * 60 + dM;
            const report = rH * 60 + rM;

            if (delivery < report) {
                const pad = (n: number) => String(n).padStart(2, "0");
                toast.error(`La Hora de Entrega (${pad(dH)}:${pad(dM)}) no puede ser menor que la Hora de Reporte (${pad(rH)}:${pad(rM)}).`);
                return;
            }
        }

        updateData();
    };

    const extractYMD = (v: any): { y: number; m: number; d: number } | null => {
        if (!v) return null;
        if (v instanceof Date) {
            return { y: v.getFullYear(), m: v.getMonth() + 1, d: v.getDate() };
        }
        const s = String(v);
        const m = s.match(/(\d{4})-(\d{2})-(\d{2})/);
        if (!m) return null;
        return { y: +m[1], m: +m[2], d: +m[3] };
    };

    const compareCalendarDay = (delivery: any, report: any) => {
        const a = extractYMD(delivery);
        const b = extractYMD(report);
        if (!a || !b) return { valid: false, sameDay: false, isDeliveryBefore: false, isDeliveryAfter: false };

        const na = a.y * 10000 + a.m * 100 + a.d;
        const nb = b.y * 10000 + b.m * 100 + b.d;

        return {
            valid: true,
            sameDay: na === nb,
            isDeliveryBefore: na < nb,
            isDeliveryAfter: na > nb
        };
    };

    const pad = (num: number) => num.toString().padStart(2, '0');

    useEffect(() => {
        if (!bean?.DeliveryDate) {
            setBean((prev: any) => ({
                ...prev,
                DeliveryDate: _single.getCurrenDate()
            }));
        }
    }, [bean?.DeliveryDate, setBean]);

    return (
        <div className="row">
            {/* <div className="col-md-6"><h5>bean</h5><PrintJson json={bean} /></div>
            <div className="col-md-6"><h5>props</h5><PrintJson json={props} /></div> */}

            <div className="col-md-6">
                <InputDate notDate name="" label="Fecha de Entrega" value={bean.DeliveryDate} setDate={(e) => { setBean({ ...bean, DeliveryDate: e }) }} />
            </div>
            <div className="col-md-6">
                <label>Hora de Entrega de la maquina</label>
                <div className="row">
                    <div className="col-md-6">
                        <select
                            className="form-control"
                            value={bean.DeliveryToH ?? ""}
                            onChange={(e) => setBean({ ...bean, DeliveryToH: parseInt(e.target.value) })}
                        >
                            <option value="">HH</option>
                            {[...Array(24)].map((_, i) => (
                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <select
                            className="form-control"
                            value={bean.DeliveryToM ?? ""}
                            onChange={(e) => setBean({ ...bean, DeliveryToM: parseInt(e.target.value) })}
                        >
                            <option value="">MM</option>
                            {[...Array(60)].map((_, i) => (
                                <option key={i * 1} value={i * 1}>{(i * 1).toString().padStart(2, '0')}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <label>Actividad realizada</label>
                <textarea className="form-control" value={bean.ActivityDescription} onChange={(e) => { setBean({ ...bean, ActivityDescription: e.target.value }) }} />
            </div>

            <div className="col-md-6 mt-4">
                <BasicButton eventClick={() => { onExportMap() }} icon="ri-send-plane-line" children={`Enviar`} />
            </div>
        </div>
    )
}